(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["babou-header"]) return;
  try {
    
  (function () {
    const fixedHeader = document.getElementById('site-header-fixed');
    const REVEAL_THRESHOLD = 120;
    let lastScrollY = window.scrollY;
    let ticking = false;

    function showFixed() {
      fixedHeader.classList.add('is-visible');
      fixedHeader.removeAttribute('inert');
    }
    function hideFixed() {
      fixedHeader.classList.remove('is-visible');
      fixedHeader.setAttribute('inert', '');
    }
    function updateHeader() {
      const y = window.scrollY;
      const scrollingDown = y > lastScrollY;
      if (y <= REVEAL_THRESHOLD || scrollingDown) {
        hideFixed();
      } else {
        showFixed();
      }
      lastScrollY = y;
      ticking = false;
    }
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });

    // Mobile Drawer Open/Close
    const drawer = document.getElementById('mobile-menu-drawer');
    const backdrop = document.getElementById('mobile-menu-backdrop');
    function openMenu() {
      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeMenu() {
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
    document.querySelectorAll('[data-menu-toggle]').forEach((btn) => btn.addEventListener('click', openMenu));
    document.querySelectorAll('[data-menu-close]').forEach((btn) => btn.addEventListener('click', closeMenu));
    backdrop.addEventListener('click', closeMenu);

    // Animated Mobile Accordion Toggle Logic
    document.querySelectorAll('[data-accordion-trigger]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const content = toggle.nextElementSibling;
        const isOpen = content.classList.contains('is-open');

        // Toggle active state for smooth rotation and accordion expansion
        toggle.classList.toggle('is-active', !isOpen);
        content.classList.toggle('is-open', !isOpen);
      });
    });

    // Search Toggle Logic
    function openSearch(header, panel) {
      header.classList.add('header-reveal--search-open');
      panel.classList.add('is-open');
      window.setTimeout(() => panel.querySelector('input')?.focus(), 200);
    }

    function closeSearch(header, panel) {
      panel.classList.remove('is-open');
      header.classList.remove('header-reveal--search-open');
    }

    document.querySelectorAll('[data-search-toggle]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const header = btn.closest('[data-header]');
        const panel = header.querySelector('[data-search-panel]');
        panel.classList.contains('is-open') ? closeSearch(header, panel) : openSearch(header, panel);
      });
    });

    document.querySelectorAll('[data-search-close]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const header = btn.closest('[data-header]');
        const panel = btn.closest('[data-search-panel]');
        closeSearch(header, panel);
      });
    });

    // Close search when clicking outside header or pressing Escape
    document.addEventListener('click', (e) => {
      document.querySelectorAll('[data-header].header-reveal--search-open').forEach((header) => {
        if (!header.contains(e.target)) {
          const panel = header.querySelector('[data-search-panel]');
          closeSearch(header, panel);
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeMenu();
      document.querySelectorAll('[data-header].header-reveal--search-open').forEach((header) => {
        const panel = header.querySelector('[data-search-panel]');
        closeSearch(header, panel);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["babou-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('babou-instagram')) {
    const BABOU_IG_ICONS = {
      VIDEO:
        '<svg viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4Zm3 5.5v7l6-3.5-6-3.5Z"/></svg>',
      CAROUSEL_ALBUM:
        '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 2h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4Z"/><path d="M2 8v10a4 4 0 0 0 4 4h10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
    };

    customElements.define(
      'babou-instagram',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.dataset.feedUrl) return;
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                  this.observer.disconnect();
                  this.load();
                }
              },
              { rootMargin: '400px 0px' }
            );
            this.observer.observe(this);
          } else {
            this.load();
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        async load() {
          const url = this.dataset.feedUrl;
          const key = 'babou-ig:' + url;
          let data = null;

          try {
            const cached = JSON.parse(sessionStorage.getItem(key) || 'null');
            if (cached && Date.now() - cached.t < 3600000) data = cached.d;
          } catch (e) {}

          if (!data) {
            try {
              const res = await fetch(url);
              if (!res.ok) throw new Error(res.status);
              data = await res.json();
              try {
                sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data }));
              } catch (e) {}
            } catch (e) {
              this.fail();
              return;
            }
          }

          const limit = parseInt(this.dataset.limit, 10) || 5;
          const posts = (data.posts || []).slice(0, limit);
          if (!posts.length) {
            this.fail();
            return;
          }

          this.replaceChildren(...posts.map((post, i) => this.tile(post, i)));
        }

        fail() {
          const section = this.closest('.babou-ig');
          if (section) section.classList.add('babou-ig--error');
        }

        imageSizes(index) {
          const layout = this.dataset.layout;
          if (layout === 'strip') return '(min-width: 750px) 20vw, 42vw';
          if (layout === 'row') return '(min-width: 750px) 28vw, 70vw';
          if (index === 0) return '(min-width: 750px) 50vw, 100vw';
          return '(min-width: 750px) 25vw, 50vw';
        }

        tile(post, index) {
          const link = document.createElement('a');
          link.className = 'babou-ig__tile';
          link.href = post.permalink;
          link.target = '_blank';
          link.rel = 'noopener';

          const caption = (post.prunedCaption || post.caption || '').trim();
          link.setAttribute(
            'aria-label',
            caption ? 'View on Instagram: ' + caption.slice(0, 120) : 'View on Instagram'
          );

          const sizes = post.sizes || {};
          const srcset = ['small', 'medium', 'large', 'full']
            .map((k) => sizes[k])
            .filter((s) => s && s.mediaUrl && s.width)
            .map((s) => s.mediaUrl + ' ' + s.width + 'w')
            .join(', ');

          const img = document.createElement('img');
          img.alt = '';
          img.loading = 'lazy';
          img.decoding = 'async';
          img.src =
            (sizes.large && sizes.large.mediaUrl) ||
            (post.mediaType === 'VIDEO' ? post.thumbnailUrl : post.mediaUrl);

          if (srcset) {
            img.srcset = srcset;
            img.sizes = this.imageSizes(index);
          }

          img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
          link.appendChild(img);

          const icon = BABOU_IG_ICONS[post.mediaType];
          if (icon) {
            const badge = document.createElement('span');
            badge.className = 'babou-ig__type';
            badge.setAttribute('aria-hidden', 'true');
            badge.innerHTML = icon;
            link.appendChild(badge);
          }

          if (this.dataset.captions === 'true' && caption) {
            const overlay = document.createElement('span');
            overlay.className = 'babou-ig__caption';
            overlay.setAttribute('aria-hidden', 'true');
            const text = document.createElement('span');
            text.textContent = caption;
            overlay.appendChild(text);
            link.appendChild(overlay);
          }

          return link;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
